export default __webpack_public_path__ + "6b7a8179fbb467baf5f25342d6a3487e.png";